import type { MarketingNote } from '../../../../api/venue-marketing';
import { ageLabel, formatAbsoluteDateTime } from '../../../../utils/relative-age';

import { NoteKindPill } from './NoteKindPill';

/**
 * The kind, who wrote the note and how long ago. A long name is cut with an
 * ellipsis (the full text is on hover) so the edit and delete icons beside it
 * always have room and never wrap onto a line of their own.
 *
 * An imported note shows only its source, such as "Aug 2026 audit". Its created
 * date is when the import ran, not when the audit was written, so an age beside
 * it would mislead.
 */
export function NoteByline({ note }: { note: MarketingNote }) {
  const imported = note.source === 'AUDIT_IMPORT';
  const age = ageLabel(note.createdAt);
  return (
    <span style={{ display: 'flex', alignItems: 'center', gap: 7, minWidth: 0, flex: '1 1 auto' }}>
      <NoteKindPill kind={note.kind} done={note.isDone} />
      <span
        title={imported ? note.authorName : `${note.authorName} · ${age}`}
        style={{
          fontSize: 10.5,
          color: 'var(--nb-muted)',
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {note.authorName}
        {!imported && (
          <>
            {' · '}
            <span title={formatAbsoluteDateTime(note.createdAt)}>{age}</span>
          </>
        )}
      </span>
    </span>
  );
}
